export const Context = Object.freeze({
  SERVICIO: 'Servicio',
  VENTA: 'Venta',
});



// WEBPACK FOOTER //
// ./src/components/Pagar/constants.js